module.exports = __webpack_public_path__ + "img/miniPro_judai_make.a3ef9cd9.png";